// TODO(ryanbrott): Make this a monotonic clock.
export function utimeNow(): number {
  return Date.now() * 1000;
}
